var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Estimated Manual Effort")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticStyle:{"font-size":"40px"}},[_vm._v(_vm._s(_vm.manualEffort)+" hours")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }